<!--
 * @Descripttion: 流程草稿列表
 * @Author: jschen
 * @Date: 2021-09-05 16:39:41
 * @LastEditors: liaoyijun
 * @LastEditTime: 2022-03-23 15:42:28
-->
<template>
    <div v-show="visible" class="approval-content">
        <el-table v-loading="loading" :data="draftRecords" style="width: 100%" :height="255" @row-click="rowDraftClick">
            <el-table-column prop="title" label="草稿标题" :show-overflow-tooltip="true">
                <template slot-scope="scope">
                    <div class="draft-title">
                        {{ scope.row.title }}
                    </div>
                </template>
            </el-table-column>
            <el-table-column prop="templateName" label="表单模板名称" align="center" width="150"> </el-table-column>
            <el-table-column prop="createDate" sortable label="创建时间" width="100" align="center">
                <template slot-scope="scope">
                    <span>{{ scope.row.createDate | dateFilter }}</span>
                </template>
            </el-table-column>
            <div slot="append" style="width:100%;height:30px;"></div>
            <div slot="empty" class="empty">
                <img src="@/assets/pics/no-empty.png" />
                <span>暂无内容</span>
            </div>
        </el-table>
    </div>
</template>
<script>
import { findByDraft } from "@/api";
export default {
    props: {
        visible: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            loading: false,
            draftRecords: [],
            searchDraftOpt: {
                title: "", // 标题
                current: 1,
                size: 30,
            },
        };
    },
    methods: {
        loadData() {
            this.findByDraft();
        },
        refresh() {
            this.searchDraftOpt = {
                title: "", // 标题
                current: 1,
                size: 30,
            };
            this.loadData();
        },
        changeSearchOps(item) {
            this.searchDraftOpt = {
                ...this.searchDraftOpt,
                ...item,
            };
        },
        rowDraftClick(row) {
            this.handleRouterJump(1, row.draftUrl, "", true);
        },
        // 流程草稿
        async findByDraft() {
            this.loading = true;
            try {
                const { body, code, message } = await findByDraft({
                    ...this.searchDraftOpt,
                });
                if (code === "0000") {
                    this.draftRecords = body.records;
                } else {
                    this.$message.error(message);
                }
            } catch (err) {
                console.error(err);
            }
            this.loading = false;
        },
    },
};
</script>

<style lang="scss" scoped>
@import "../style.scss";
</style>
